import { useState } from 'react'
import { Modal } from 'antd'
import { useAuthStore } from '@/stores/authStore'

const URL_DO_VIDEO =
  'https://customer-tt8s3c2vz888asa9.cloudflarestream.com/69696756a50c5e3cacde6f05c0a1b7dc/iframe'

/**
 * Vídeo de apresentação do painel, uma vez por usuário.
 *
 * A marca de "já viu" é por usuárioId e não uma chave única, porque o mesmo navegador é usado por
 * mais de uma pessoa do parceiro — uma chave global esconderia o vídeo de quem nunca o viu.
 */
export function ModalDeVideoDeBoasVindas() {
  const usuarioId = useAuthStore((s) => s.usuario?.id)
  const [fechado, setFechado] = useState(false)

  if (usuarioId == null || fechado || jaViuOVideo(usuarioId)) return null

  function fechar() {
    if (usuarioId != null) marcarComoVisto(usuarioId)
    setFechado(true)
  }

  return (
    <Modal
      open
      onCancel={fechar}
      footer={null}
      width={840}
      centered
      title="Bem-vindo ao painel New Driver"
      styles={{ body: { padding: 0 } }}
    >
      <div className="relative w-full pt-[56.25%]">
        <iframe
          src={URL_DO_VIDEO}
          title="Vídeo de apresentação do painel"
          className="absolute inset-0 h-full w-full border-0"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
        />
      </div>
    </Modal>
  )
}

function chaveDoUsuario(usuarioId: number): string {
  return `videoBoasVindasVisto:${usuarioId}`
}

function jaViuOVideo(usuarioId: number): boolean {
  try {
    return localStorage.getItem(chaveDoUsuario(usuarioId)) === 'true'
  } catch {
    return false
  }
}

function marcarComoVisto(usuarioId: number): void {
  try {
    localStorage.setItem(chaveDoUsuario(usuarioId), 'true')
  } catch {
    // Navegador com storage bloqueado: o vídeo reaparece, mas a tela continua utilizável.
  }
}
